import { PropsWithChildren } from "react";
import { NavLink, NavLinkProps } from "react-router";

import { cn } from "@bentolabs/kit/utils";

export const HeaderLink = ({
  children,
  className,
  ...props
}: PropsWithChildren<NavLinkProps>) => {
  return (
    <NavLink
      className={({ isActive }) => {
        return cn(
          "text-nobel flex cursor-pointer items-center justify-center rounded-[10px] px-3 py-1 transition-colors select-none",
          "text-sm",
          "hover:bg-white/5",
          isActive ? "text-white" : "text-nobel",
          isActive && "pointer-events-none bg-white/5",
          className
        );
      }}
      {...props}
    >
      {children}
    </NavLink>
  );
};
